import { render, staticRenderFns } from "./05.4-RenovationQuotation.vue?vue&type=template&id=dcb63e12&scoped=true&"
import script from "./05.4-RenovationQuotation.vue?vue&type=script&lang=js&"
export * from "./05.4-RenovationQuotation.vue?vue&type=script&lang=js&"
import style0 from "./05.4-RenovationQuotation.vue?vue&type=style&index=0&id=dcb63e12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb63e12",
  null
  
)

export default component.exports